import baseAPI from '@/http'

const router = 'api/atores'

export const atoresApi = {
    create: (ator) => baseAPI.post(router, ator),
    createAtor: (ator) => baseAPI.post(`${router}/cadastrar-ator`, ator),
    updateAtor: (ator) => baseAPI.post(`${router}/atualizar-ator`, ator),
    update: (ator) => baseAPI.put(router, ator),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-atores-por-municipio/${municipioId}`)
}